<template>
  <div class="dashboard-container">
    <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="12">
      <el-form ref="form" :model="form" :rules="rules" label-position="right" label-width="120px">
        <el-form-item label="平台" prop="platform">
          <el-select v-model="form.platform" placeholder="选择平台" @change="dealUrl">
            <el-option key="Wondfo-DMS-V3" label="Wondfo-DMS-V3" value="Wondfo-DMS-V3" />
            <el-option key="Wondfo-DMS-V4" label="Wondfo-DMS-V4" value="Wondfo-DMS-V4" />
          </el-select>
        </el-form-item>
        <el-form-item label="版本" prop="version">
          <el-input v-model="form.version" type="text" name="version" placeholder="输入版本" />
        </el-form-item>
        <el-form-item label="特征" prop="feature">
          <el-input v-model="form.feature" type="text" name="feature" placeholder="输入版本特征" />
        </el-form-item>
        <el-form-item label="修复" prop="fix">
          <el-input v-model="form.fix" type="text" name="fix" placeholder="输入版本修复内容" />
        </el-form-item>
        <el-form-item label="新增" prop="change">
          <el-input v-model="form.change" type="text" name="change" placeholder="输入版本新增内容" />
        </el-form-item>
        <el-form-item label="文件管理">
          <el-button type="success" @click="addFile">添加文件</el-button>
          <el-button type="danger" @click="delFile">删除文件</el-button>
        </el-form-item>
        <div v-for="(item, index) in form.fileList" :key="index">
          <el-divider>文件{{ index+1 }}</el-divider>
          <el-form-item label="文件名" :prop="'fileList.'+index +'.name'" :rules="fileRules.name">
            <el-input v-model="item.name" type="text" name="name" placeholder="输入文件名称，包含文件后缀" @blur="getUrl(item)" />
          </el-form-item>
          <el-form-item label="文件夹" hidden :prop="'fileList.'+index +'.path'" :rules="fileRules.path">
            <el-input v-model="item.path" type="text" name="path" placeholder="输入文件夹名称" @blur="getUrl(item)" />
          </el-form-item>
          <el-form-item label="文件大小" :prop="'fileList.'+index +'.size'" :rules="fileRules.size">
            <el-input v-model.number="item.size" type="number" name="size" placeholder="输入文件大小，单位是MB" />
          </el-form-item>
          <el-form-item label="文件链接">
            <a :href="item.url" target="_blank" style="display: block; line-height: 24px; color: #20a0ff; overflow-wrap: break-word;">{{ item.url }}</a>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">确认提交</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </div>
</template>

<script>
import { postDms } from '@/api/dms'
import { OssClient } from '@/utils/oss-client'

export default {
  name: 'Manage',
  data() {
    return {
      form: {
        platform: '',
        version: '',
        feature: '',
        fix: '',
        change: '',
        fileList: [{
          name: '',
          path: '',
          size: null,
          url: ''
        }]
      },
      rules: {
        platform: [{ required: true, message: '必填', trigger: 'change' }],
        version: [{ required: true, message: '必填', trigger: 'change' }]
      },
      fileRules: {
        name: [{ required: true, message: '必填', trigger: 'change' }],
        size: [{ required: true, message: '必填', trigger: 'change' }]
      },
      client: null
    }
  },
  mounted() {
    this.getClient()
  },
  methods: {
    async getClient() {
      this.client = await OssClient('wondfo-soft')
    },
    addFile() {
      this.form.fileList.push({
        name: '',
        path: '',
        size: null,
        url: ''
      })
    },
    delFile() {
      if (this.form.fileList.length > 1) {
        this.form.fileList.pop()
      }
    },
    getUrl(item) {
      if (!item.name) { return }
      /* let path
      if (this.form.platform === 'Wondko-DMS-Pet') {
        path = process.env.VUE_APP_OSS_DMS_PET
      } else if (this.form.platform === 'Wondfo-DMS') {
        path = process.env.VUE_APP_OSS_DMS
      }*/
      let url
      if (item.path) {
        url = this.client.signatureUrl(item.path + '/' + item.name, { expires: 3600 * 12 })
        url = url.replace(/wondfo-soft.oss-cn-shenzhen.aliyuncs.com/, 'cdn-oss-soft.wondfo.cloud')
      } else {
        url = this.client.signatureUrl(item.name, { expires: 3600 * 12 })
        url = url.replace(/wondfo-soft.oss-cn-shenzhen.aliyuncs.com/, 'cdn-oss-soft.wondfo.cloud')
      }
      item.url = url
    },
    dealUrl() {
      /* let path
      if (this.form.platform === 'Wondko-DMS-Pet') {
        path = process.env.VUE_APP_OSS_DMS_PET
      } else if (this.form.platform === 'Wondfo-DMS') {
        path = process.env.VUE_APP_OSS_DMS
      }*/
      this.form.fileList.map((value, key) => {
        if (value.name && value.path) {
          const url = this.client.signatureUrl(value.path + '/' + value.name, { expires: 3600 * 12 })
          value.url = url
        } else if (value.name && !value.path) {
          const url = this.client.signatureUrl(value.name, { expires: 3600 * 12 })
          value.url = url
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const _this = this
          postDms(this.form).then(response => {
            _this.$router.push({ name: 'version' }).catch(err => { console.log(err) })
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    padding: 30px;
  }
}
</style>
